const SocialList = () => {
  return (
    <ul className="follow__list">
      <li className="follow__list-item">
        <a
          title="facebook"
          target="_blank"
          rel="noreferrer"
          href="https://www.facebook.com/Retoucher-Online-110356848115656/"
        >
          <i className="icon__facebook_active" />
        </a>
      </li>
      <li className="follow__list-item">
        <a
          title="twitter"
          target="_blank"
          rel="noreferrer"
          href="https://twitter.com/Retoucher_O"
        >
          <i className="icon__twitter_active" />
        </a>
      </li>
      <li className="follow__list-item">
        <a
          title="instagram"
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/retoucher.online.free/"
        >
          <i className="icon__instagram_active" />
        </a>
      </li>
      <li className="follow__list-item">
        <a
          title="pinterest"
          target="_blank"
          rel="noreferrer"
          href="https://www.pinterest.ru/RetoucherOnline/"
        >
          <i className="icon__pinterest_active" />
        </a>
      </li>
    </ul>
  );
};

export default SocialList;
